module.exports = __webpack_public_path__ + "img/content-img3_3.6ef6adb6.png";